import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IEntitlementRepository } from '../../repositories/interfaces/iEntitlementRepository';
import { ITvodPricingTemplateResponse } from '../../../entity/interface/iEntitlements';
export interface IGetTvodPricingTemplatesUseCase {
    execute(operator: string): Promise<ITvodPricingTemplateResponse>;
}

export class GetTvodPricingTemplatesUseCase implements IGetTvodPricingTemplatesUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get getTvodPricingTemplatesPinRepository(): IEntitlementRepository {
        return container.resolve<IEntitlementRepository>(DI.REPOSITORIES.IEntitlementRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(operator: string): Promise<ITvodPricingTemplateResponse> {
        return this.getTvodPricingTemplatesPinRepository.getTvodPricingTemplates(operator);
    }
}
